import { render, staticRenderFns } from "./UpgradeItemList.vue?vue&type=template&id=6f0f4def&scoped=true&"
import script from "./UpgradeItemList.vue?vue&type=script&lang=js&"
export * from "./UpgradeItemList.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeItemList.vue?vue&type=style&index=0&id=6f0f4def&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f4def",
  null
  
)

export default component.exports